import React, { useMemo, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getWaterUseStatusListQuery } from '../../../../slices/waterUseStatus/thunk';
import AddEditWaterUseStatusModal from './Add_Edit/AddEditWaterUseStatus';
import DeleteWaterUseStatusModal from './Delete/DeleteWaterUseStatus';
import { Icons } from '../../../../utils/Icons';

const WaterUseStatusList = () => {
	const history = useNavigate();

	const [dataWaterUseStatus, setDataWaterUseStatus] = useState({});
	const [refetch, setRefetch] = useState(0);

	const toggleRefetch = () => {
		setRefetch(prev => prev + 1);
	};
	const [isEdit, setIsEdit] = useState(false);

	// Delete WaterUseStatus
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataWaterUseStatus(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataWaterUseStatus(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'waterUseStatuses',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const dataData = cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(dataData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const dataData = cellProps.row.original;
													handleClickDelete(dataData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getWaterUseStatusListQuery}
								baseFilters={{
									disable: { $eq: false }
								}}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								refetchRemoteData={refetch}
								nameFile={'estados-uso'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataWaterUseStatus({});
											handleToggleModal();
										},
										title: 'Crear Estado de Uso',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditWaterUseStatusModal
				dataWaterUseStatus={dataWaterUseStatus}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
			<DeleteWaterUseStatusModal
				dataWaterUseStatus={dataWaterUseStatus}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
				toggleRefetch={toggleRefetch}
			/>
		</React.Fragment>
	);
};

export default WaterUseStatusList;
